import Immutable from 'immutable';
import AppConstants from '../constants/AppConstants';

const initialState = Immutable.Map({
  appVersion: null,
  basePath: '/v2',
  baseURL: null,
  coreAssets: Immutable.Map(),
  currentURL: null,
  apiGatewayURL: null,
  libraryDomain: null,
  airbrakeConfig: Immutable.Map(),
  featureOverrides: Immutable.Map(),
  gaTrackingId: null,
  enableWebpackHMR: false,
  enableReduxDevTools: false,
  localBranch: null,
  mobileApp: false
});

export default function app(state = initialState, action) {
  switch (action.type) {
    case AppConstants.LOAD_APP_CONFIG: {
      return state.merge(action.appConfig);
    }

    default:
      return state;
  }
}
